// "Reload to update" banner (CODE_REVIEW S13/S14): shown when a new version is waiting, or when the
// one-time cross-origin-isolation reload was postponed because photos were open.
import { X } from 'lucide-react';
import { useSwUpdate } from '../../app/swUpdate';
import { useT } from '../../i18n';

export function UpdateBanner() {
  const t = useT();
  const { reason, apply } = useSwUpdate();
  if (!reason) return null;
  return (
    <div
      role="status"
      data-testid="update-banner"
      style={{
        position: 'fixed',
        right: 16,
        top: 56,
        zIndex: 95,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        padding: '8px 14px',
        background: 'var(--toast-bg)',
        color: 'var(--toast-text)',
        border: '1px solid var(--line)',
        borderRadius: 6,
      }}
    >
      <span>{t(reason === 'update' ? 'updateReady' : 'isolationReady')}</span>
      <button onClick={apply}>{t('reloadNow')}</button>
      <button aria-label={t('close')} onClick={() => useSwUpdate.setState({ reason: null })}>
        <X className="icon" aria-hidden="true" />
      </button>
    </div>
  );
}
